import { useState } from "react";
import { LinkApi } from "../../../redux/api/LinkApi";
import { SvgIcon } from "@progress/kendo-react-common";
import * as svg from '@progress/kendo-svg-icons';
import { ILink } from "../../../types/ILink";

interface EditBarProps {
    link: ILink;
    setEditingLinkId: React.Dispatch<any>;
    newLink: boolean
}

export const EditBar = (props: EditBarProps) => {
    const [updateLinkEndpoint] = LinkApi.useUpdateLinkMutation();
    const [createLinkEndpont] = LinkApi.useCreateLinkMutation();
    const [editedLink, setEditedLink] = useState<ILink>({ ...props.link });

    const handleUpdate = () => {
        if (!(editedLink.Link && editedLink.Link_Display)) return
        if (props.newLink) {
            createLinkEndpont(editedLink)
        } else {
            updateLinkEndpoint(editedLink);
        }

        props.setEditingLinkId(null);
    };

    return (
        <form className="edit-link-form" >
            <div className="editing-fields">
                <input
                    placeholder="Display"
                    autoFocus
                    type="text"
                    value={editedLink.Link_Display}
                    onChange={(e) => setEditedLink({ ...editedLink, Link_Display: e.target.value.slice(0, 20) })}
                    onKeyDown={(event) => {
                        if (event.key === "Enter" || event.key === "Escape") handleUpdate();
                    }}
                />
                <input
                    placeholder="Url"
                    type="text"
                    value={editedLink.Link}
                    onChange={(e) => setEditedLink({ ...editedLink, Link: e.target.value })}
                    onKeyDown={(event) => {
                        if (event.key === "Enter" || event.key === "Escape" || (event.key === "Tab" && !event.shiftKey)) handleUpdate();
                    }}
                />
            </div>
            <div className="editing-icons">
                <SvgIcon className="save-icon" icon={svg.saveIcon} onClick={() => { if (editedLink.Link_Display && editedLink.Link) handleUpdate() }} />
                <SvgIcon className="cancel-icon" icon={svg.xIcon} onClick={() => props.setEditingLinkId(null)} />
            </div>
        </form>
    );
};
